import Moment from 'moment';
import MomentTimeZone from 'moment-timezone';
import { AppLocale } from 'src/models/modules';

export const arriveTimeFormat = 'HH:mm:ss';

export const setTimeOnDate = (date: string, time: string): string => {
    return date.split('T')[0] + 'T' + time + 'Z';
}

export const getDate = (dateTime: string): string => {
    return dateTime.split('T')[0];
}

export const getTime = (dateTime: string): string => {
    if (dateTime.includes('T')) {
        let time = dateTime.split('T')[1];
        if (time && time.includes('+')) {
            time = time.split('+')[0];
        }
        if (time && time.includes('Z')) {
            time = time.split('Z')[0];
        }
        if (time && time.includes('.')) {
            time = time.split('.')[0];
        }
        return time;
    }
    return ''
}

export const getUtcDateTime = (time: string, date?: string): string => {
    date = getDate(date || Moment(new Date()).toISOString());
    return (Moment(date + 'T' + time).toISOString())
}

export const getUtcTime = (time: string): string => {
    return getTime(getUtcDateTime(time));
}

export const getOffsetString = (timeZone: string) => {
    const localOffset = Moment().format('Z');
    const offset = MomentTimeZone.tz(timeZone).format('Z');
    return localOffset === offset ? '' : ` (GMT${offset})`;
}

export const isValidTime = (dateTime: string | null, freeIntervals: string[]): boolean => {
    if (!dateTime) {
        return false;
    }
    const time = getTime(dateTime);
    return !!(freeIntervals.find(t => time.startsWith(t)));
}

export const isValidDate = (dateTime: string, freeDays: string[] | null): boolean => {
    const date = getDate(dateTime);
    return !!(freeDays && freeDays.find(d => getDate(d) === date));
}

export const getYearMonthFormat = (locale: string): string => {
    return locale === AppLocale.Hu ? 'yyyy. MMMM' : 'MMMM yyyy';
}